module.exports = __webpack_public_path__ + "static/media/calendar.a71d4364.svg";